import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import PostHooks from "../../../Api/PostHooks";
import { useState } from "react";
import { MuiTelInput } from "mui-tel-input";
import AlertComponent from "../../../Components/AlertComponent";

const PurchaseAirtimeForm = ({ user, onClose, onSuccess }) => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [other, setOther] = useState("");
  const msisdn = watch("msisdn");

  const [loading, response, request] = PostHooks();

  const purchase = async (e) => {
    try {
      let formData = {
        customer_entity_id: user?.id,
        amount: e.amount,
        others: other,
        other_msisdn: other === "YES" ? msisdn.replace("+", "") : "",
      };

      const airResp = await request({
        url: "sell_inventory_airtime",
        body: formData,
      });

      if (airResp && airResp.status === 200 && airResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Airtime purchase successfull!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          airResp?.data?.StatusMessage ??
          airResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(purchase)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          mt: "5px",
        }}
      >
        <InputLabel id="who">Buy airtime for</InputLabel>
        <Select
          labelId="who"
          id="who"
          defaultValue=""
          value={other}
          label="Buy airtime for"
          onChange={(e) => setOther(e.target.value)}
          required
        >
          <MenuItem value="NO">Buy for My Number </MenuItem>
          <MenuItem value="YES">Buy for Other Number </MenuItem>
        </Select>
      </FormControl>

      {other === "YES" && (
        <>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <Controller
              name="msisdn"
              control={control}
              render={({ field }) => (
                <MuiTelInput
                  // sx={{
                  //   border: "1px solid black",
                  // }}
                  defaultCountry="KE"
                  disableFormatting
                  value={msisdn}
                  // onChange={(e) => setMsisdn(e)}
                  {...field}
                />
              )}
            />
          </FormControl>
        </>
      )}

      <FormControl
        fullWidth
        error={!!errors.amount}
        sx={{
          mt: 2,
        }}
      >
        <InputLabel htmlFor="amount">Amount</InputLabel>
        <OutlinedInput
          id="amount"
          type="number"
          {...register("amount", { required: true })}
          label="Amount"
          inputProps={{ step: "any" }}
        />
        {errors.amount && (
          <FormHelperText>Please enter an amount!</FormHelperText>
        )}
      </FormControl>

      <Box
        sx={{
          pt: "40px",
          gap: 2,
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="text" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={loading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default PurchaseAirtimeForm;
